import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Check if this is an external API request
    const isExternalApi = req.url.startsWith('http://') && !req.url.includes('localhost') ||
                         req.url.startsWith('https://') && !req.url.includes(window.location.hostname);


    // Only set Content-Type for requests that need it (POST, PUT, PATCH with body)
    // Exclude GET requests, external APIs, FormData uploads, and requests with existing Content-Type
    const shouldSetContentType = req.method !== 'GET' &&
                                  req.body !== null &&
                                  !isExternalApi &&
                                  !(req.body instanceof FormData) &&
                                  !req.headers.has('Content-Type');

    const headers: { [key: string]: string } = {};
    if (shouldSetContentType) {
      headers['Content-Type'] = 'application/json';
    }

    const authReq = req.clone({
      setHeaders: headers,
    });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.error("error", error);
        }
        return throwError(error);
      })
    );
  }
}
